<template>
  <section
    v-if="isVisible"
    class="sales-summary"
    aria-label="Статистика продаж"
  >
    <header class="sales-summary__header">
      <div class="sales-summary__heading">
        <span class="sales-summary__icon">
          <ChartNoAxesCombined
            :size="22"
            aria-hidden="true"
          />
        </span>
        <div>
          <h2>Статистика продаж</h2>
          <p>Основные показатели работы</p>
        </div>
      </div>
    </header>

    <dl class="sales-summary__list">
      <div
        v-for="(field, index) in getComponentFields"
        :key="`sales-summary-${index}`"
        class="sales-summary__item"
        :class="`sales-summary__item--${getColor(field, index)}`"
      >
        <dt class="sales-summary__title">
          <span class="sales-summary__metric-icon">
            <component
              :is="field.icon"
              :size="20"
              aria-hidden="true"
            />
          </span>

          <span>{{ field.title }}</span>
        </dt>
        <dd
          v-if="isFieldCurrency(field)"
          class="sales-summary__value"
        >
          {{ priceToFormat(data[field.name]) }}
        </dd>

        <dd
          v-else
          class="sales-summary__value"
        >
          {{ data[field.name] }}
        </dd>
      </div>
    </dl>
  </section>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { priceToFormat } from '@/helper'

import {
  ChartNoAxesCombined,
  TrendingUp,
  Receipt,
  Package
} from 'lucide-vue'

const colors = ['blue', 'purple', 'green', 'yellow']

export default {
  name: 'SalesSummary',
  components: {
    ChartNoAxesCombined,
    TrendingUp,
    Receipt,
    Package
  },
  data () {
    return {
      data: []
    }
  },
  computed: {
    ...mapGetters('settings', ['getFields']),
    getComponentFields () {
      return this.getFields?.['dashboard-info']?.salesSummary || []
    },
    isVisible () {
      return this.getComponentFields.length > 0 && Object.keys(this.data || {}).length > 0
    }
  },
  mounted () {
    this.loadData()

    this.$bus.on('update-sales-summary', this.loadData)
  },
  beforeDestroy () {
    this.$bus.off('update-sales-summary', this.loadData)
  },
  methods: {
    ...mapActions('info', ['loadSalesSummary']),
    priceToFormat,
    async loadData () {
      const { data } = await this.loadSalesSummary() || {}

      this.data = data
    },
    getColor (field, index) {
      return colors.includes(field.color) ? field.color : colors[index % colors.length]
    },
    isFieldCurrency ({ type }) {
      return type === 'currency'
    }
  }
}
</script>

<style scoped lang="scss" src="./style.scss" />
